'use strict';

function getRow(opts) {
  return {
    tag: 'div',
    attrs: {
      className: {
        'row': true
      }
    },
    children: opts.children,
    key: opts.key
  };
}

module.exports = getRow;


/*****************
 ** WEBPACK FOOTER
 ** ./~/uvdom-bootstrap/lib/getRow.js
 ** module id = 1075
 ** module chunks = 0
 **/